import React from 'react';
import { CtaButton } from './CtaButton';
import { Lock, Download, Smartphone } from 'lucide-react';
export function MidPageCTA() {
  return <section id="oferta" className="py-20 px-4 bg-brand-purple" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <div className="bg-brand-purpleDark rounded-3xl p-8 md:p-12 text-center border border-white/10 shadow-2xl" data-id="element-120">
          <p className="text-brand-yellow text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-121">
            Todo por solo
          </p>
          <div className="mb-2" data-id="element-122">
            <span className="text-gray-400 line-through text-2xl" data-id="element-123">$30.000</span>
          </div>
          <div className="text-7xl md:text-8xl font-serif font-bold text-brand-yellow mb-2" data-id="element-124">
            $9.999
          </div>
          <p className="text-white/80 text-lg mb-8" data-id="element-125">= menos que un delivery</p>

          <CtaButton text="→ Quiero acceder ahora" size="xl" className="w-full mb-8" data-id="element-126" />

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-white/70 font-medium" data-id="element-127">
            <div className="flex items-center gap-1.5" data-id="element-128">
              <Lock className="w-4 h-4" data-id="element-129" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-130">
              <Download className="w-4 h-4" data-id="element-131" /> Descarga instantánea
            </div>
            <div className="flex items-center gap-1.5" data-id="element-132">
              <Smartphone className="w-4 h-4" data-id="element-133" /> Funciona en cualquier
              dispositivo
            </div>
          </div>
        </div>
      </div>
    </section>;
}